import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';

import {
    setMotivo, clearMotivo,
    setPeea, clearPeea,
    setHabitusExterior, clearHabitusExterior,
    setCabezaYCuello, clearCabezaYCuello,
    setTorax, clearTorax,
    setAbdomen, clearAbdomen,
    setExtremidades, clearExtremidades,
    setPiel, clearPiel,
    setGenitales, clearGenitales,
    setOtro, clearOtro,
    setFc, clearFc,
    setFr, clearFr,
    setTa, clearTa,
    setT, clearT,
    setSaO2, clearSaO2,
    setPeso, clearPeso,
    setTalla, clearTalla,
    setImc, clearImc,
    setFem, clearFem,
    setPronostico, clearPronostico,
    setComentarios, clearComentarios,
    setCitaFecha, clearCitaFecha,
    setCitaHora, clearCitaHora,
    setCitaMotivo, clearCitaMotivo,
    setCitaDuracion, clearCitaDuracion,
    setCitaComentario, clearCitaComentario,
    setDiagnosticos, clearDiagnosticos,
    setDiagnosticosData, clearDiagnosticosData,
    setMedicamentos, clearMedicamentos,
    setEstudios,
    clearEstudios,
} from "../../../redux/slices/consulta";

import { useNewForm, useFormValidation } from '../../../hooks';
import { useConfiguracionConsulta } from '../hooks/useConfiguracionConsulta';
import { usePacienteConsultaHistorial } from '../hooks/useHistorial';
import { useMotivo } from '../hooks/useMotivo';
import { useEstudio } from '../hooks/useEstudio';
import { usePacienteConsultaCrear } from '../hooks/usePacienteConsultaCrear';

import { DateInput, Error, Forbidden, LightButton, Loader, ModalContainer, MultiFormMedicamentos, NumberInput, PesoInput, PresionArterialInput, PrimaryButton, ReactMultiValueSelectInput, ReactSelectSingleKeyInput, TemperaturaInput, TextAreaInput, TextInput, TimeInput } from '../../../components';
// import { MultiFormEstudiosConsulta } from '../../../components';
import { HistorialConsultaModal } from '../../Modals/HistorialConsulta';
import { ViewConsultaModal } from "../../Modals/ViewConsulta";

import { formatDate } from '../../../helpers/formatDate';

import { eliminarUndefined } from '../../../helpers';

import styles from '../PacienteConsulta.module.css';

export const Consulta = ({ data = null, dataMigrada = false, dataDiagnosticos = [], refetchDataConsulta, onFinalizarConsulta }) => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    let { id } = useParams();

    const { permisos } = useSelector(state => state.auth);

    const date = new Date();
    const dia = String(date.getDate()).padStart(2, "0");
    const mes = String(date.getMonth() + 1).padStart(2, "0");
    const año = String(date.getFullYear());

    const [inactivoFlag, setInactivoFlag] = useState(false);
    const [horarioFlag, setHorarioFlag] = useState(false);
    const [empalmadaFlag, setEmpalmadaFlag] = useState(false);

    const [citaMotivoReset, setCitaMotivoReset] = useState(true);

    const [diagnosticosReset, setDiagnosticosResetFields] = useState(moment().unix());

    const [medicamentosReset, setMedicamentosResetFields] = useState(moment().unix());

    const [estudiosReset, setEstudiosResetFields] = useState(moment().unix());

    const [statusHistorialModal, setStatusHistorialModal] = useState(false);

    const [statusViewModal, setStatusViewModal] = useState(false);
    const [viewConsulta, setViewConsulta] = useState(null);
    const [citaPendiente, setCitaPendiente] = useState(null);
    const [cita, setCita] = useState(null);

    const activeInactivoFlag = () => {
        setInactivoFlag(true);
    }

    const activeHorarioFlag = () => {
        setHorarioFlag(true);
    }

    const activeEmpalmadaFlag = () => {
        setEmpalmadaFlag(true);
    }

    const showHistorialModal = () => {
        setStatusHistorialModal(true);
    }
    
    const hideHistorialModal = () => {
        setStatusHistorialModal(false);
    }

    const showViewModal = (consulta, citaPendiente, cita) => {
        setViewConsulta(consulta);
        setCitaPendiente(citaPendiente);
        setCita(cita);
        setStatusViewModal(true);
    }

    const hideViewModal = () => {
        onFinalizarConsulta();
        setStatusViewModal(false);
        navigate(`/paciente/view/${id}`);
    }

    const hideClearResumen = () => {
        hideViewModal();
    }

    const { configuracionConsultaQuery: { isLoading, isError, data: configuracionConsulta } } = useConfiguracionConsulta();

    const { pacienteConsultaHistorialQuery: { isLoading: isLoadingHistorial, isError: isErrorHistorial, data: historialConsulta } } = usePacienteConsultaHistorial(id);

    const { motivoQuery: { isLoading: isLoadingMotivo, isError: isErrorMotivo, data: motivos } } = useMotivo();

    const { estudioQuery: { isLoading: isLoadingEstudio, isError: isErrorEstudio, data: estudiosData } } = useEstudio();

    const { createConsultaMutation: { mutate: createConsulta, isPending } } = usePacienteConsultaCrear(id);

    const { motivo, peea, habitusExterior, cabezaYCuello, torax, abdomen, extremidades, piel, genitales, otro, fc, fr, ta, t, saO2, peso, talla, imc, fem, citaFecha, citaHora, citaMotivo, citaComentario, diagnosticos, diagnosticosData, medicamentos, estudios, pronostico, comentarios, onInputChange, onMultipleInputChange } = useNewForm({ motivo: (data != null) ? data.datosGenerales.motivo : '', peea: (data != null) ? data.datosGenerales.peea : '', habitusExterior: (data != null) ? data.datosGenerales.exploracionFisica.habitusExterior : '', cabezaYCuello: (data != null) ? data.datosGenerales.exploracionFisica.cabezaYCuello : '', torax: (data != null) ? data.datosGenerales.exploracionFisica.torax : '', abdomen: (data != null) ? data.datosGenerales.exploracionFisica.abdomen : '', extremidades: (data != null) ? data.datosGenerales.exploracionFisica.extremidades : '', piel: (data != null) ? data.datosGenerales.exploracionFisica.piel : '', genitales: (data != null) ? data.datosGenerales.exploracionFisica.genitales : '', otro: (data != null) ? data.datosGenerales.exploracionFisica.otro : '', fc: (data != null) ? data.datosGenerales.signosVitales.fc : '', fr: (data != null) ? data.datosGenerales.signosVitales.fr : '', ta: (data != null) ? data.datosGenerales.signosVitales.ta : '', t: (data != null) ? data.datosGenerales.signosVitales.t : '', saO2: (data != null) ? data.datosGenerales.signosVitales.saO2 : '', peso: (data != null) ? data.datosGenerales.signosVitales.peso : '', talla: (data != null) ? data.datosGenerales.signosVitales.talla : '', imc: (data != null) ? data.datosGenerales.signosVitales.imc : '0', fem: (data != null) ? data.datosGenerales.signosVitales.fem : '', citaFecha: (data != null) ? data.proximaCita.fecha : '', citaHora: (data != null) ? data.proximaCita.hora : '', citaMotivo: (data != null) ? data.proximaCita.motivo : '', citaDuracion: (data != null) ? data.proximaCita.duracion : '', citaComentario: (data != null) ? data.proximaCita.comentario : '', diagnosticos: (data != null) ? data.diagnosticos : [], diagnosticosData: (data != null) ? data.diagnosticosData : [], medicamentos: (data != null) ? data.medicamentos : [], estudios: (data != null) ? data.estudios : [], pronostico: (data != null) ? data.pronostico : '', comentarios: (data != null) ? data.comentarios : '' });

    const { citaDuracion, onInputChange: onInputDuracionChange } = useNewForm({ citaDuracion: (data != null) ? data.proximaCita.duracion : '' });

    const { isFormValid: isFormStaticValid, formValidationStatus: formStaticValidationStatus, formFields: formStaticFields, startFormValidation: startFormStaticValidation, setFormFieldValidation: setFormStaticFieldValidation, setMultipleFormFieldValidation: setMultipleFormStaticFieldValidation } = useFormValidation([{field: 'motivo', default: true}, {field: 'peea', default: true}, {field: 'habitusExterior', default: true}, {field: 'cabezaYCuello', default: true}, {field: 'torax', default: true}, {field: 'abdomen', default: true}, {field: 'extremidades', default: true}, {field: 'piel', default: true}, {field: 'genitales', default: true}, {field: 'otro', default: true}, {field: 'fc', default: true}, {field: 'fr', default: true}, {field: 'ta', default: true}, {field: 't', default: true}, {field: 'saO2', default: true}, {field: 'peso', default: true}, {field: 'talla', default: true}, {field: 'imc', default: true}, {field: 'fem', default: true}, {field: 'citaFecha', default: true}, {field: 'citaHora', default: true}, {field: 'citaMotivo', default: true}, {field: 'citaComentario', default: true}, {field: 'diagnosticosData', default: true}, {field: 'pronostico', default: true}, {field: 'comentarios', default: true}]);

    const { isFormValid: isFormDuracionValid, formValidationStatus: formDuracionValidationStatus, formFields: formDuracionFields, startFormValidation: startFormDuracionValidation, setFormFieldValidation: setFormDuracionFieldValidation } = useFormValidation([{field: 'citaDuracion', default: true}]);

    const { isFormValid: isFormDiagnosticosValid, formValidationStatus: formDiagnosticosValidationStatus, formFields: formDiagnosticosFields, startFormValidation: startFormDiagnosticosValidation, setFormFieldValidation: setFormDiagnosticosFieldValidation } = useFormValidation([{field: 'diagnosticos', default: true}]);
    
    const { isFormValid: isFormMedicamentosValid, formValidationStatus: formMedicamentosValidationStatus, formFields: formMedicamentosFields, startFormValidation: startFormMedicamentosValidation, setFormFieldValidation: setFormMedicamentosFieldValidation } = useFormValidation([{field: 'medicamentos', default: true}]);

    const { isFormValid: isFormEstudiosValid, formValidationStatus: formEstudiosValidationStatus, formFields: formEstudiosFields, startFormValidation: startFormEstudiosValidation, setFormFieldValidation: setFormEstudiosFieldValidation } = useFormValidation([{field: 'estudios', default: true}]);

    useEffect(() => {
        if(formStaticFields['motivo'].isValid){
            dispatch(setMotivo({
                paciente: id,
                motivo: motivo
            }));
        }else{
            dispatch(clearMotivo(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [motivo, formStaticFields['motivo'].isValid]);

    useEffect(() => {
        if(formStaticFields['peea'].isValid){
            dispatch(setPeea({
                paciente: id,
                peea: peea
            }));
        }else{
            dispatch(clearPeea(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [peea, formStaticFields['peea'].isValid]);

    useEffect(() => {
        if(formStaticFields['habitusExterior'].isValid){
            dispatch(setHabitusExterior({
                paciente: id,
                habitusExterior: habitusExterior
            }));
        }else{
            dispatch(clearHabitusExterior(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [habitusExterior, formStaticFields['habitusExterior'].isValid]);

    useEffect(() => {
        if(formStaticFields['cabezaYCuello'].isValid){
            dispatch(setCabezaYCuello({
                paciente: id,
                cabezaYCuello: cabezaYCuello
            }));
        }else{
            dispatch(clearCabezaYCuello(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cabezaYCuello, formStaticFields['cabezaYCuello'].isValid]);

    useEffect(() => {
        if(formStaticFields['torax'].isValid){
            dispatch(setTorax({
                paciente: id,
                torax: torax
            }));
        }else{
            dispatch(clearTorax(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [torax, formStaticFields['torax'].isValid]);

    useEffect(() => {
        if(formStaticFields['abdomen'].isValid){
            dispatch(setAbdomen({
                paciente: id,
                abdomen: abdomen
            }));
        }else{
            dispatch(clearAbdomen(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [abdomen, formStaticFields['abdomen'].isValid]);

    useEffect(() => {
        if(formStaticFields['extremidades'].isValid){
            dispatch(setExtremidades({
                paciente: id,
                extremidades: extremidades
            }));
        }else{
            dispatch(clearExtremidades(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [extremidades, formStaticFields['extremidades'].isValid]);

    useEffect(() => {
        if(formStaticFields['piel'].isValid){
            dispatch(setPiel({
                paciente: id,
                piel: piel
            }));
        }else{
            dispatch(clearPiel(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [piel, formStaticFields['piel'].isValid]);

    useEffect(() => {
        if(formStaticFields['genitales'].isValid){
            dispatch(setGenitales({
                paciente: id,
                genitales: genitales
            }));
        }else{
            dispatch(clearGenitales(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [genitales, formStaticFields['genitales'].isValid]);

    useEffect(() => {
        if(formStaticFields['otro'].isValid){
            dispatch(setOtro({
                paciente: id,
                otro: otro
            }));
        }else{
            dispatch(clearOtro(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [otro, formStaticFields['otro'].isValid]);

    useEffect(() => {
        if(formStaticFields['fc'].isValid){
            dispatch(setFc({
                paciente: id,
                fc: fc
            }));
        }else{
            dispatch(clearFc(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fc, formStaticFields['fc'].isValid]);

    useEffect(() => {
        if(formStaticFields['fr'].isValid){
            dispatch(setFr({
                paciente: id,
                fr: fr
            }));
        }else{
            dispatch(clearFr(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fr, formStaticFields['fr'].isValid]);

    useEffect(() => {
        if(formStaticFields['ta'].isValid){
            dispatch(setTa({
                paciente: id,
                ta: ta
            }));
        }else{
            dispatch(clearTa(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ta, formStaticFields['ta'].isValid]);

    useEffect(() => {
        if(formStaticFields['t'].isValid){
            dispatch(setT({
                paciente: id,
                t: t
            }));
        }else{
            dispatch(clearT(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [t, formStaticFields['t'].isValid]);

    useEffect(() => {
        if(formStaticFields['saO2'].isValid){
            dispatch(setSaO2({
                paciente: id,
                saO2: saO2
            }));
        }else{
            dispatch(clearSaO2(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saO2, formStaticFields['saO2'].isValid]);

    useEffect(() => {
        if(formStaticFields['peso'].isValid){
            dispatch(setPeso({
                paciente: id,
                peso: peso
            }));
            let imc = 0;
            if(peso !== '' && talla !== ''){
                imc = peso / ((talla / 100) * (talla / 100));
            }
            onInputChange({ target: { name: 'imc', value: imc.toFixed(2) } });
        }else{
            dispatch(clearPeso(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [peso, formStaticFields['peso'].isValid]);

    useEffect(() => {
        if(formStaticFields['talla'].isValid){
            dispatch(setTalla({
                paciente: id,
                talla: talla
            }));
            let imc = 0;
            if(peso !== '' && talla !== ''){
                imc = peso / ((talla / 100) * (talla / 100));
            }
            onInputChange({ target: { name: 'imc', value: imc.toFixed(2) } });
        }else{
            dispatch(clearTalla(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [talla, formStaticFields['talla'].isValid]);

    useEffect(() => {
        if(formStaticFields['imc'].isValid){
            dispatch(setImc({
                paciente: id,
                imc: imc
            }));
        }else{
            dispatch(clearImc(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [imc, formStaticFields['imc'].isValid]);

    useEffect(() => {
        if(formStaticFields['fem'].isValid){
            dispatch(setFem({
                paciente: id,
                fem: fem
            }));
        }else{
            dispatch(clearFem(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fem, formStaticFields['fem'].isValid]);

    useEffect(() => {
        if(formStaticFields['citaFecha'].isValid){
            dispatch(setCitaFecha({
                paciente: id,
                fecha: citaFecha
            }));
        }else{
            dispatch(clearCitaFecha(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [citaFecha, formStaticFields['citaFecha'].isValid]);

    useEffect(() => {
        if(formStaticFields['citaHora'].isValid){
            dispatch(setCitaHora({
                paciente: id,
                hora: citaHora
            }));
        }else{
            dispatch(clearCitaHora(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [citaHora, formStaticFields['citaHora'].isValid]);

    const handleMotivoChange = (e) => {
        onInputChange(e);

        onInputDuracionChange({ target: { name: 'citaDuracion', value: motivos.find(motivo => String(motivo._id) === String(e.target.value)).duracion } });
    }

    useEffect(() => {
        if(formStaticFields['citaMotivo'].isValid){
            dispatch(setCitaMotivo({
                paciente: id,
                motivo: citaMotivo
            }));
        }else{
            dispatch(clearCitaMotivo(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [citaMotivo, formStaticFields['citaMotivo'].isValid]);

    useEffect(() => {
        if(formDuracionFields['citaDuracion'].isValid){
            dispatch(setCitaDuracion({
                paciente: id,
                duracion: citaDuracion
            }));
        }else{
            dispatch(clearCitaDuracion(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [citaDuracion, formDuracionFields['citaDuracion'].isValid]);

    useEffect(() => {
        if(formStaticFields['citaComentario'].isValid){
            dispatch(setCitaComentario({
                paciente: id,
                comentario: citaComentario
            }));
        }else{
            dispatch(clearCitaComentario(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [citaComentario, formStaticFields['citaComentario'].isValid]);

    useEffect(() => {
        if(formDiagnosticosFields['diagnosticos'].isValid){
            dispatch(setDiagnosticos({
                paciente: id,
                diagnosticos: diagnosticos
            }));
        }else{
            dispatch(clearDiagnosticos(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [diagnosticos, formDiagnosticosFields['diagnosticos'].isValid]);

    useEffect(() => {
        if(formStaticFields['diagnosticosData'].isValid){
            dispatch(setDiagnosticosData({
                paciente: id,
                diagnosticosData: diagnosticosData
            }));
        }else{
            dispatch(clearDiagnosticosData(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [diagnosticosData, formStaticFields['diagnosticosData'].isValid]);

    useEffect(() => {
        if(formMedicamentosFields['medicamentos'].isValid){
            dispatch(setMedicamentos({
                paciente: id,
                medicamentos: medicamentos
            }));
        }else{
            dispatch(clearMedicamentos(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [medicamentos, formMedicamentosFields['medicamentos'].isValid]);

    useEffect(() => {
        if(formEstudiosFields['estudios'].isValid){
            dispatch(setEstudios({
                paciente: id,
                estudios: estudios
            }));
        }else{
            dispatch(clearEstudios(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [estudios, formEstudiosFields['estudios'].isValid]);

    useEffect(() => {
        if(formStaticFields['pronostico'].isValid){
            dispatch(setPronostico({
                paciente: id,
                pronostico: pronostico
            }));
        }else{
            dispatch(clearPronostico(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pronostico, formStaticFields['pronostico'].isValid]);

    useEffect(() => {
        if(formStaticFields['comentarios'].isValid){
            dispatch(setComentarios({
                paciente: id,
                comentarios: comentarios
            }));
        }else{
            dispatch(clearComentarios(id));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comentarios, formStaticFields['comentarios'].isValid]);

    const handleResetCitaMotivo = () => {
        setCitaMotivoReset(false);
        setTimeout(() => {
            setCitaMotivoReset(true);
        }, 1);
    }

    const handleResetDiagnosticos = () => {
        setDiagnosticosResetFields(false);
        setTimeout(() => {
            setDiagnosticosResetFields(true);
        }, 1);
    }

    const handleResetMedicamentos = () => {
        setMedicamentosResetFields(false);
        setTimeout(() => {
            setMedicamentosResetFields(true);
        }, 1);
    }

    const handleResetEstudios = () => {
        setEstudiosResetFields(false);
        setTimeout(() => {
            setEstudiosResetFields(true);
        }, 1);
    }

    const handleClearValues = () => {
        onMultipleInputChange([{ target: { name: 'motivo', value: '' } }, { target: { name: 'peea', value: '' } }, { target: { name: 'habitusExterior', value: '' } }, { target: { name: 'cabezaYCuello', value: '' } }, { target: { name: 'torax', value: '' } }, { target: { name: 'abdomen', value: '' } }, { target: { name: 'extremidades', value: '' } }, { target: { name: 'piel', value: '' } }, { target: { name: 'genitales', value: '' } }, { target: { name: 'otro', value: '' } }, { target: { name: 'fc', value: '' } }, { target: { name: 'fr', value: '' } }, { target: { name: 'ta', value: '' } }, { target: { name: 't', value: '' } }, { target: { name: 'saO2', value: '' } }, { target: { name: 'peso', value: '' } }, { target: { name: 'talla', value: '' } }, { target: { name: 'imc', value: '0' } }, { target: { name: 'fem', value: '' } }, { target: { name: 'citaFecha', value: '' } }, { target: { name: 'citaHora', value: '' } }, { target: { name: 'citaMotivo', value: '' } }, { target: { name: 'citaComentario', value: '' } }, { target: { name: 'diagnosticos', value: [] } }, { target: { name: 'diagnosticosData', value: '' } }, { target: { name: 'medicamentos', value: [] } }, { target: { name: 'estudios', value: [] } }, { target: { name: 'pronostico', value: '' } }, { target: { name: 'comentarios', value: '' } }]);
        onInputDuracionChange({ target: { name: 'citaDuracion', value: '' } });
        setMultipleFormStaticFieldValidation([{ name: 'motivo', value: true }, { name: 'peea', value: true }, { name: 'habitusExterior', value: true }, { name: 'cabezaYCuello', value: true }, { name: 'torax', value: true }, { name: 'abdomen', value: true }, { name: 'extremidades', value: true }, { name: 'piel', value: true }, { name: 'genitales', value: true }, { name: 'otro', value: true }, { name: 'fc', value: true }, { name: 'fr', value: true }, { name: 'ta', value: true }, { name: 't', value: true }, { name: 'saO2', value: true }, { name: 'peso', value: true }, { name: 'talla', value: true }, { name: 'imc', value: true }, { name: 'fem', value: true }, { name: 'citaFecha', value: true }, { name: 'citaHora', value: true }, { name: 'citaMotivo', value: true }, { name: 'citaComentario', value: true }, { name: 'diagnosticosData', value: true }, { name: 'pronostico', value: true }, { name: 'comentarios', value: true }]);
        setFormDuracionFieldValidation('citaDuracion', true);
        setFormDiagnosticosFieldValidation('diagnosticos', true);
        setFormMedicamentosFieldValidation('medicamentos', true);
        setFormEstudiosFieldValidation('estudios', true);
        handleResetCitaMotivo();
        handleResetDiagnosticos();
        handleResetMedicamentos();
        handleResetEstudios();
        setInactivoFlag(false);
        setHorarioFlag(false);
        setEmpalmadaFlag(false);
        onFinalizarConsulta();
    }

    const handleTerminar = () => {
        handleClearValues();
        navigate(`/paciente/view/${id}`);
    }

    const handleResumen = ({ consulta, consultaData, citaPendiente, cita }) => {
        showViewModal(consulta, citaPendiente, cita);
    }
    
    const onSubmit = (e) => {
        e.preventDefault();

        if(formStaticValidationStatus === 'checked' && isFormStaticValid != null && formDuracionValidationStatus === 'checked' && isFormDuracionValid != null && formDiagnosticosValidationStatus === 'checked' && isFormDiagnosticosValid != null && formMedicamentosValidationStatus === 'checked' && isFormMedicamentosValid != null && formEstudiosValidationStatus === 'checked' && isFormEstudiosValid != null){
            createConsulta({ data: eliminarUndefined({
                motivo: (configuracionConsulta.historiaClinica.motivoConsulta) ? motivo : undefined,
                peea: (configuracionConsulta.historiaClinica.peea) ? peea : undefined,
                habitusExterior: (configuracionConsulta.exploracionFisica.habitusExterior) ? habitusExterior : undefined,
                cabezaYCuello: (configuracionConsulta.exploracionFisica.cabezaCuello) ? cabezaYCuello : undefined,
                torax: (configuracionConsulta.exploracionFisica.torax) ? torax : undefined,
                abdomen: (configuracionConsulta.exploracionFisica.abdomen) ? abdomen : undefined,
                extremidades: (configuracionConsulta.exploracionFisica.extremidades) ? extremidades : undefined,
                piel: (configuracionConsulta.exploracionFisica.piel) ? piel : undefined,
                genitales: (configuracionConsulta.exploracionFisica.genitales) ? genitales : undefined,
                otro: (configuracionConsulta.exploracionFisica.otro) ? otro : undefined,
                fc: (configuracionConsulta.signosVitales.frecuenciaCardiaca) ? fc : undefined,
                fr: (configuracionConsulta.signosVitales.frecuenciaRespiratoria) ? fr : undefined,
                ta: (configuracionConsulta.signosVitales.presionArterial) ? ta : undefined,
                t: (configuracionConsulta.signosVitales.temperatura && t !== '') ? parseFloat(t) : undefined,
                saO2: (configuracionConsulta.signosVitales.sa02) ? saO2 : undefined,
                peso: (configuracionConsulta.signosVitales.peso) ? peso : undefined,
                talla: (configuracionConsulta.signosVitales.talla) ? talla : undefined,
                imc: (configuracionConsulta.signosVitales.imc && peso !== '' && talla !== '') ? imc : undefined,
                fem: (configuracionConsulta.signosVitales.fem) ? fem : undefined,
                citaFecha,
                citaHora,
                citaMotivo,
                citaDuracion,
                citaComentario,
                diagnosticos: diagnosticos.map(diagnosticoAux => diagnosticoAux._id),
                // diagnosticos: diagnosticos.filter(diagnosticoAux => diagnosticoAux.diagnostico !== '' || diagnosticoAux.diagnosticoData !== '').map(diagnosticoAux => {
                //     return {
                //         id: (String(diagnosticoAux.id).includes('|||nuevo|||')) ? '0' : diagnosticoAux.id,
                //         diagnostico: diagnosticoAux.diagnostico,
                //         diagnosticoData: diagnosticoAux.diagnosticoData,
                //         activo: diagnosticoAux.activo
                //     }
                // }),
                diagnosticosData,
                medicamentos: medicamentos.filter(medicamentoAux => medicamentoAux.medicamento !== '').map(medicamentoAux => {
                    return {
                        id: (String(medicamentoAux.id).includes('|||nuevo|||')) ? '0' : medicamentoAux.id,
                        medicamento: medicamentoAux.medicamento,
                        inicio: medicamentoAux.inicio,
                        administracionPrescrita: medicamentoAux.administracionPrescrita,
                        modalidadPrescripcion: medicamentoAux.modalidadPrescripcion,
                        dosis: medicamentoAux.dosis,
                        frecuencia: parseInt(medicamentoAux.frecuencia),
                        tipoFrecuencia: medicamentoAux.tipoFrecuencia,
                        diasSemana: medicamentoAux.diasSemana,
                        tipoDuracion: medicamentoAux.tipoDuracion,
                        duracion: parseInt(medicamentoAux.duracion),
                        dosisRescate: medicamentoAux.dosisRescate,
                        contadorDosis: medicamentoAux.contadorDosis,
                        contadorDosisDisponibles: parseInt(medicamentoAux.contadorDosisDisponibles),
                        contadorDosisLimite: parseInt(medicamentoAux.contadorDosisLimite),
                        comentarios: medicamentoAux.comentarios,
                        activo: medicamentoAux.activo
                    }
                }),
                estudios: estudios.map(estudio => ({
                    _id: (estudio._id.includes('||created||')) ? '0' : estudio._id,
                    nombre: estudio.nombre
                })),
                // estudios: estudios.map(estudio => ({
                //     _id: (estudio.estudio.includes('||created||')) ? '0' : estudio.estudio,
                //     nombre: estudio.text
                // })),
                pronostico,
                comentarios,
                citaInactivoConfirmacion: inactivoFlag,
                citaHorarioConfirmacion: horarioFlag,
                citaEmpalmadaConfirmacion: empalmadaFlag
            }, { motivo: undefined, peea: undefined, habitusExterior: undefined, cabezaYCuello: undefined, torax: undefined, abdomen: undefined, extremidades: undefined, piel: undefined, genitales: undefined, otro: undefined, fc: undefined, fr: undefined, ta: undefined, t: undefined, saO2: undefined, peso: undefined, talla: undefined, imc: undefined, fem: undefined, citaFecha: undefined, citaHora: undefined, citaMotivo: undefined, citaDuracion: undefined, citaComentario: undefined, pronostico: undefined, comentarios: undefined }), id, success:  handleResumen, onInactivo: activeInactivoFlag, onHorario: activeHorarioFlag, onEmpalmada: activeEmpalmadaFlag});
        }else{
            startFormStaticValidation();
            startFormDuracionValidation();
            startFormDiagnosticosValidation();
            startFormMedicamentosValidation();
            startFormEstudiosValidation();
        }
    }

    return (permisos.consultaRead || permisos.consultaCreate || permisos.consultaUpdate) ? (
        <>
            {(isLoading || isLoadingMotivo || isLoadingEstudio || isLoadingHistorial)
                ? <Loader />
                : <>
                    {(isError || isErrorMotivo || isErrorEstudio || isErrorHistorial)
                        ? <Error />
                        : <>
                            {(permisos.consultaRead || permisos.consultaUpdate || permisos.receta) &&
                            <div className={styles.historialBtnDiv}>
                                <div className={styles.historialBtnContainer} onClick={() => showHistorialModal()}>
                                    <div className='centrar'>
                                        <div className={styles.historialBtn}></div>
                                    </div>
                                    <div className={styles.historialBtnText}>
                                        <div>Historial</div>
                                    </div>
                                </div>
                            </div>
                            }
                            {(permisos.consultaCreate)
                            ? <div className="row">
                                <div className="col">
                                    {(dataMigrada) &&
                                    <div className={styles.consultationWarning}>
                                        <strong>Precaución:</strong> Los datos de consulta existentes provienen de una migración. Revise el historial del paciente antes de crear una nueva consulta para confirmar la información.
                                    </div>
                                    }
                                    <form onSubmit={onSubmit}>
                                        <div className="row mt-4 mb-2">
                                            <div className="col">
                                                <span className={"me-3 " + styles.consultaSubHeader}>Consulta</span> { (configuracionConsulta.historiaClinica.fecha) && <span className={styles.consultaLabel}>Dia</span> } { (configuracionConsulta.historiaClinica.fecha) && <span className={styles.consultaText}>{formatDate(dia, mes, año)}</span> }
                                            </div>
                                        </div>
                                        { (configuracionConsulta.historiaClinica.motivoConsulta) &&
                                        <div className="row">
                                            <div className="col-md-12 col-lg-4">
                                                <TextInput
                                                    formFieldStatus={ formStaticFields['motivo'].status }
                                                    label="Motivo de consulta"
                                                    name="motivo"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ motivo }
                                                />
                                            </div>
                                        </div>
                                        }
                                        { (configuracionConsulta.historiaClinica.peea) &&
                                        <div className="row">
                                            <div className="col">
                                                <TextAreaInput
                                                    formFieldStatus={ formStaticFields['peea'].status }
                                                    label="PEEA"
                                                    name="peea"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ peea }
                                                />
                                            </div>
                                        </div>
                                        }
                                        { (configuracionConsulta.exploracionFisica.habitusExterior || configuracionConsulta.exploracionFisica.cabezaCuello || configuracionConsulta.exploracionFisica.torax || configuracionConsulta.exploracionFisica.abdomen || configuracionConsulta.exploracionFisica.piel || configuracionConsulta.exploracionFisica.extremidades || configuracionConsulta.exploracionFisica.genitales || configuracionConsulta.exploracionFisica.otro) &&
                                        <div className="row mt-4 mb-2">
                                            <div className="col">
                                                <span className={"me-3 " + styles.consultaSubHeader}>Exploración física</span>
                                            </div>
                                        </div>
                                        }
                                        { (configuracionConsulta.exploracionFisica.habitusExterior) &&
                                        <div className="row">
                                            <div className="col">
                                                <TextAreaInput
                                                    formFieldStatus={ formStaticFields['habitusExterior'].status }
                                                    label="Habitus exterior"
                                                    name="habitusExterior"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ habitusExterior }
                                                />
                                            </div>
                                        </div>
                                        }
                                        { (configuracionConsulta.exploracionFisica.cabezaCuello) &&
                                        <div className="row">
                                            <div className="col">
                                                <TextAreaInput
                                                    formFieldStatus={ formStaticFields['cabezaYCuello'].status }
                                                    label="Cabeza y cuello"
                                                    name="cabezaYCuello"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ cabezaYCuello }
                                                />
                                            </div>
                                        </div>
                                        }
                                        { (configuracionConsulta.exploracionFisica.torax) &&
                                        <div className="row">
                                            <div className="col">
                                                <TextAreaInput
                                                    formFieldStatus={ formStaticFields['torax'].status }
                                                    label="Tórax"
                                                    name="torax"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ torax }
                                                />
                                            </div>
                                        </div>
                                        }
                                        { (configuracionConsulta.exploracionFisica.abdomen) &&
                                        <div className="row">
                                            <div className="col">
                                                <TextAreaInput
                                                    formFieldStatus={ formStaticFields['abdomen'].status }
                                                    label="Abdomen"
                                                    name="abdomen"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ abdomen }
                                                />
                                            </div>
                                        </div>
                                        }
                                        { (configuracionConsulta.exploracionFisica.piel) &&
                                        <div className="row">
                                            <div className="col">
                                                <TextAreaInput
                                                    formFieldStatus={ formStaticFields['piel'].status }
                                                    label="Piel"
                                                    name="piel"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ piel }
                                                />
                                            </div>
                                        </div>
                                        }
                                        { (configuracionConsulta.exploracionFisica.extremidades) &&
                                        <div className="row">
                                            <div className="col">
                                                <TextAreaInput
                                                    formFieldStatus={ formStaticFields['extremidades'].status }
                                                    label="Extremidades"
                                                    name="extremidades"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ extremidades }
                                                />
                                            </div>
                                        </div>
                                        }
                                        { (configuracionConsulta.exploracionFisica.genitales) &&
                                        <div className="row">
                                            <div className="col">
                                                <TextAreaInput
                                                    formFieldStatus={ formStaticFields['genitales'].status }
                                                    label="Genitales"
                                                    name="genitales"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ genitales }
                                                />
                                            </div>
                                        </div>
                                        }
                                        { (configuracionConsulta.exploracionFisica.otro) &&
                                        <div className="row">
                                            <div className="col">
                                                <TextAreaInput
                                                    formFieldStatus={ formStaticFields['otro'].status }
                                                    label="Otro"
                                                    name="otro"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ otro }
                                                />
                                            </div>
                                        </div>
                                        }
                                        { (configuracionConsulta.signosVitales.frecuenciaCardiaca || configuracionConsulta.signosVitales.frecuenciaRespiratoria || configuracionConsulta.signosVitales.presionArterial || configuracionConsulta.signosVitales.temperatura || configuracionConsulta.signosVitales.sa02 || configuracionConsulta.signosVitales.peso || configuracionConsulta.signosVitales.talla || configuracionConsulta.signosVitales.imc || configuracionConsulta.signosVitales.fem) &&
                                        <div className="row mt-4 mb-2">
                                            <div className="col">
                                                <span className={"me-3 " + styles.consultaSubHeader}>Signos vitales</span>
                                            </div>
                                        </div>
                                        }
                                        <div className="row">
                                            { (configuracionConsulta.signosVitales.frecuenciaCardiaca) &&
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                                                <NumberInput
                                                    formFieldStatus={ formStaticFields['fc'].status }
                                                    label="Frecuencia cardíaca (lpm)"
                                                    name="fc"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ fc }
                                                    min={0}
                                                    step={1}
                                                />
                                            </div>
                                            }
                                            { (configuracionConsulta.signosVitales.frecuenciaRespiratoria) &&
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                                                <NumberInput
                                                    formFieldStatus={ formStaticFields['fr'].status }
                                                    label="Frecuencia respiratoria (rpm)"
                                                    name="fr"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ fr }
                                                    min={0}
                                                    step={1}
                                                />
                                            </div>
                                            }
                                            { (configuracionConsulta.signosVitales.presionArterial) &&
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                                                <PresionArterialInput
                                                    formFieldStatus={ formStaticFields['ta'].status }
                                                    label="Presión arterial (mmHg)"
                                                    name="ta"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ ta }
                                                />
                                            </div>
                                            }
                                            { (configuracionConsulta.signosVitales.temperatura) &&
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                                                <TemperaturaInput
                                                    formFieldStatus={ formStaticFields['t'].status }
                                                    label="Temperatura (°C)"
                                                    name="t"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ t.toString() }
                                                />
                                            </div>
                                            }
                                            { (configuracionConsulta.signosVitales.sa02) &&
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                                                <NumberInput
                                                    formFieldStatus={ formStaticFields['saO2'].status }
                                                    label="Saturación de oxígeno (%)"
                                                    name="saO2"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ saO2 }
                                                    min={0}
                                                    max={100}
                                                    step={1}
                                                />
                                            </div>
                                            }
                                            { (configuracionConsulta.signosVitales.peso) &&
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                                                <PesoInput
                                                    formFieldStatus={ formStaticFields['peso'].status }
                                                    label="Peso (Kg)"
                                                    name="peso"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ peso.toString() }
                                                />
                                            </div>
                                            }
                                            { (configuracionConsulta.signosVitales.talla) &&
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                                                <NumberInput
                                                    formFieldStatus={ formStaticFields['talla'].status }
                                                    label="Talla (cm)"
                                                    name="talla"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ talla }
                                                    min={0}
                                                    step={1}
                                                />
                                            </div>
                                            }
                                            { (configuracionConsulta.signosVitales.imc) &&
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                                                <NumberInput
                                                    disabled={ true }
                                                    formFieldStatus={ formStaticFields['imc'].status }
                                                    label="IMC (kg/m2)"
                                                    name="imc"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ imc }
                                                    min={0}
                                                    step={1}
                                                />
                                            </div>
                                            }
                                            { (configuracionConsulta.signosVitales.fem) &&
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                                                <NumberInput
                                                    formFieldStatus={ formStaticFields['fem'].status }
                                                    label="FEM (ml)"
                                                    name="fem"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ fem }
                                                    min={0}
                                                    step={1}
                                                />
                                            </div>
                                            }
                                        </div>
                                        <div className="row mt-4 mb-2">
                                            <div className="col">
                                                <span className={"me-3 " + styles.consultaSubHeader}>Diagnóstico</span>
                                            </div>
                                        </div>
                                        {(diagnosticosReset) &&
                                        <div className="row">
                                            <div className="col">
                                                <ReactMultiValueSelectInput
                                                    formsStatus={ formDiagnosticosFields['diagnosticos'].status }
                                                    label='CIE10'
                                                    name="diagnosticos"
                                                    onChange={ onInputChange }
                                                    placeholder='Selecciona diagnosticos...'
                                                    setFormFieldValidation={ setFormDiagnosticosFieldValidation }
                                                    value={diagnosticos}
                                                    values={dataDiagnosticos}
                                                />
                                            </div>
                                        </div>
                                        }
                                        {(diagnosticosReset) &&
                                        <div className="row">
                                            <div className="col">
                                                <TextAreaInput
                                                    formFieldStatus={ formStaticFields['diagnosticosData'].status }
                                                    label="Diagnóstico"
                                                    name="diagnosticosData"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ diagnosticosData }
                                                />
                                            </div>
                                        </div>
                                        }
                                        <div className="row mt-4 mb-2">
                                            <div className="col">
                                                <span className={"me-3 " + styles.consultaSubHeader}>Medicamentos</span>
                                            </div>
                                        </div>
                                        {(medicamentosReset) &&
                                        <div className="row">
                                            <div className="col">
                                                <MultiFormMedicamentos
                                                    formsStatus="checked"
                                                    // formsStatus={ formMedicamentosFields['medicamentos'].status }
                                                    name="medicamentos"
                                                    onFormsChange={ onInputChange }
                                                    reset={medicamentosReset}
                                                    setFormValidation={ () => {} }
                                                    // setFormValidation={ setFormMedicamentosFieldValidation }
                                                    value={medicamentos}
                                                />
                                            </div>
                                        </div>
                                        }
                                        <div className="row mt-4 mb-2">
                                            <div className="col">
                                                <span className={"me-3 " + styles.consultaSubHeader}>Estudios</span>
                                            </div>
                                        </div>
                                        {(estudiosReset) &&
                                        <div className="row">
                                            <div className="col">
                                                {/* <MultiFormEstudiosConsulta
                                                    formsStatus="checked"
                                                    // formsStatus={ formMedicamentosFields['medicamentos'].status }
                                                    name="estudios"
                                                    onFormsChange={ onInputChange }
                                                    reset={estudiosReset}
                                                    setFormValidation={ () => {} }
                                                    // setFormValidation={ setFormMedicamentosFieldValidation }
                                                    value={estudios}
                                                /> */}
                                                <ReactMultiValueSelectInput
                                                    formsStatus={ formEstudiosFields['estudios'].status }
                                                    name="estudios"
                                                    onChange={ onInputChange }
                                                    placeholder='Selecciona estudios...'
                                                    setFormFieldValidation={ setFormEstudiosFieldValidation }
                                                    value={estudios}
                                                    values={estudiosData}
                                                />
                                            </div>
                                        </div>
                                        }
                                        {(permisos.citaCreate) && <>
                                        <div className="row mt-4 mb-2">
                                            <div className="col">
                                                <span className={"me-3 " + styles.consultaSubHeader}>Próxima cita</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <DateInput
                                                    formFieldStatus={ formStaticFields['citaFecha'].status }
                                                    label="Fecha"
                                                    name="citaFecha"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ citaFecha }
                                                />
                                            </div>
                                            <div className="col-6">
                                                <TimeInput
                                                    formFieldStatus={ formStaticFields['citaHora'].status }
                                                    label="Hora"
                                                    name="citaHora"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ citaHora }
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            {(citaMotivoReset) && 
                                            <div className="col-6">
                                                <ReactSelectSingleKeyInput
                                                    formFieldStatus={ formStaticFields['citaMotivo'].status }
                                                    label="Motivo"
                                                    name="citaMotivo"
                                                    onChange={ handleMotivoChange }
                                                    required={false}
                                                    requiredIndicator={false}
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={citaMotivo}
                                                    values={[{ value: '', label: '' }, ...motivos.map(motivo => ({ value: motivo._id, label: motivo.nombre }))]}
                                                />
                                            </div>
                                            }
                                            <div className="col-6">
                                                <NumberInput
                                                    formFieldStatus={ formDuracionFields['citaDuracion'].status }
                                                    label="Duración (min)"
                                                    name="citaDuracion"
                                                    onChange={ onInputDuracionChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormDuracionFieldValidation }
                                                    value={citaDuracion}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <TextAreaInput
                                                    formFieldStatus={ formStaticFields['citaComentario'].status }
                                                    label="Comentario"
                                                    name="citaComentario"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ citaComentario }
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                {(inactivoFlag) && <p className={styles.helperErrorText}>La fecha seleccionada esta marcada como día inactivo en la configuración del consultorio. ¿Deseas continuar igualmente?</p>}
                                                {(horarioFlag) && <p className={styles.helperErrorText}>El periodo de tiempo seleccionado esta fuera del horario configurado para el consultorio. ¿Deseas continuar igualmente?</p>}
                                                {(empalmadaFlag) && <p className={styles.helperErrorText}>El periodo de tiempo seleccionado se empalma con otra cita previamente agendada. ¿Deseas continuar igualmente?</p>}
                                            </div>
                                        </div>
                                        </>}
                                        <div className="row mt-4">
                                            <div className="col">
                                                <span className={"me-3 " + styles.consultaSubHeader}>Pronóstico</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <TextAreaInput
                                                    formFieldStatus={ formStaticFields['pronostico'].status }
                                                    label=""
                                                    name="pronostico"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ pronostico }
                                                />
                                            </div>
                                        </div>
                                        <div className="row mt-4">
                                            <div className="col">
                                                <span className={"me-3 " + styles.consultaSubHeader}>Comentarios</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <TextAreaInput
                                                    formFieldStatus={ formStaticFields['comentarios'].status }
                                                    label=""
                                                    name="comentarios"
                                                    onChange={ onInputChange }
                                                    required={ false }
                                                    requiredIndicator={ false }
                                                    setFormFieldValidation={ setFormStaticFieldValidation }
                                                    value={ comentarios }
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 col-lg-6">
                                                
                                            </div>
                                            <div className="col-md-12 col-lg-6">
                                                <div className="row">
                                                    <div className="col-md-12 col-lg-6">
                                                        <LightButton
                                                            block={true}
                                                            disabled={isPending || formStaticValidationStatus === 'checking' || formDuracionValidationStatus === 'checking' || formDiagnosticosValidationStatus === 'checking' || formMedicamentosValidationStatus === 'checking'}
                                                            icon="X"
                                                            marginRight={true}
                                                            marginTop={false}
                                                            onClick={handleTerminar}
                                                            text="Cancelar"
                                                            type="button"
                                                        />
                                                    </div>
                                                    <div className="col-md-12 col-lg-6 mt-md-3 mt-lg-0">
                                                        <PrimaryButton
                                                            block={true}
                                                            disabled={isPending || formStaticValidationStatus === 'checking' || formDuracionValidationStatus === 'checking' || formDiagnosticosValidationStatus === 'checking' || formMedicamentosValidationStatus === 'checking'}
                                                            icon="Check"
                                                            marginTop={false}
                                                            text={(inactivoFlag || horarioFlag || empalmadaFlag) ? "Continuar" : "Guardar"}
                                                            type="submit"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            : <Forbidden />
                            }
                            { ((permisos.consultaRead || permisos.consultaUpdate || permisos.receta) && statusHistorialModal) &&
                            <ModalContainer
                                state={ statusHistorialModal }
                                hide={ hideHistorialModal }
                                content={ <HistorialConsultaModal hide={ hideHistorialModal } data={historialConsulta} configuracionConsulta={configuracionConsulta} /> }
                            />}
                            { ((permisos.consultaRead || permisos.consultaCreate || permisos.consultaUpdate || permisos.receta) && statusViewModal) &&
                            <ModalContainer
                                state={ statusViewModal }
                                hide={ hideViewModal }
                                content={ <ViewConsultaModal hide={ hideClearResumen } consulta={viewConsulta} configuracionConsulta={configuracionConsulta} citaPendiente={citaPendiente} cita={cita} /> }
                            />}
                        </>
                    }
                </>
            }
        </>
    ) : <Forbidden />
}

Consulta.propTypes = {
    data: PropTypes.object.isRequired,
    dataMigrada: PropTypes.bool.isRequired,
    dataDiagnosticos: PropTypes.array.isRequired,
    refetchDataConsulta: PropTypes.func.isRequired,
    onFinalizarConsulta: PropTypes.func.isRequired,
}
